import type { InjectionKey, ShallowRef } from 'vue';

export interface CreditSimulatorAnchor {
	/** Simulator card, filled by the card's template ref */
	card: ShallowRef<HTMLElement | null>;
	scrollToSimulator: () => void;
}

export const CREDIT_SIMULATOR_ANCHOR_KEY: InjectionKey<CreditSimulatorAnchor> =
	Symbol('credit-simulator-anchor');

// A link to the hash already in the URL does not scroll, so the links that
// lead to the simulator scroll to the card through its template ref instead.
export function provideCreditSimulatorAnchor(): CreditSimulatorAnchor {
	const card = shallowRef<HTMLElement | null>(null);
	const anchor: CreditSimulatorAnchor = {
		card,
		scrollToSimulator: () => card.value?.scrollIntoView()
	};
	provide(CREDIT_SIMULATOR_ANCHOR_KEY, anchor);
	return anchor;
}

export function useCreditSimulatorAnchor(): CreditSimulatorAnchor {
	return inject(
		CREDIT_SIMULATOR_ANCHOR_KEY,
		() => ({ card: shallowRef(null), scrollToSimulator: () => {} }),
		true
	);
}
